import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import NavMenu from './NavMenu';

const MobileNavWrapper = styled.div`
  background-color: white;
  border-bottom-style: solid;
  border-bottom-color: #e0e0e0;
  border-bottom-width: 2px;
  padding-left: 0.5em;
  padding-right: 0.5em;
  padding-bottom: 0.5em;
`;

const MobileNav = styled.nav`
  background-color: white;
  border: 1px solid #e1e1e1;
  overflow: hidden;
  padding-left: 0.7em;
  padding-right: 0.7em;
  padding-top: 0.5em;
  padding-bottom: 0.5em;
`;

const MobileNavMenu = props => {
  const { location, isLoggedIn, isOpen, navToggle } = props;

  const styles = {
    aCommon: ['l0_Py(0em)', 'l1_Py(0em)', 'l0_Px(0em)', 'l1_Px(1.071em)', 'l3_Px(2.143em)', 'Td(n):h'],
    liCommon: ['l0_Bd(n)'],
    liActive: ['Bd(n)'],
    liInactive: ['Bd(n)', 'l0_Bdtw(0px)'],
    firstChildStyles: { liCommon: ['l0_Pt(0em)', 'l0_Bd(n)', ''], aCommon: ['l0_Px(0em)', 'l0_Pt(0.556em)'] },
    lastChildStyles: { liCommon: ['l0_Bd(n)', 'Mb(0.111em)'], aCommon: ['l0_Py(0em)', 'l0_Px(0em)', 'Td(n):h'] },
    menuTop: ['Mt(0px)']
  };

  return (
    <MobileNavWrapper>
      <MobileNav>
        <NavMenu isMobile={true} isLoggedIn={isLoggedIn} location={location} styles={styles} navToggle={navToggle} isOpen={isOpen} />
      </MobileNav>
    </MobileNavWrapper>
  );
};

const { object, bool, func } = PropTypes;

MobileNavMenu.propTypes = {
  location: object.isRequired,
  isOpen: bool.isRequired,
  navToggle: func,
  isLoggedIn: bool,
};

export default MobileNavMenu;
